import { Marquee } from "@/components/ScrollAnimations";

export const TattooStylesMarquee = () => (
  <div className="relative py-6 border-y border-white/5" data-testid="tattoo-styles-marquee">
    <Marquee speed={25}>
      <span className="text-xs tracking-[0.4em] uppercase text-purple-500/60 font-bold mx-8">Blackwork</span>
      <span className="text-xs tracking-[0.4em] uppercase text-pink-500/40 font-bold mx-8">Neo-traditional</span>
      <span className="text-xs tracking-[0.4em] uppercase text-purple-500/60 font-bold mx-8">Realism</span>
      <span className="text-xs tracking-[0.4em] uppercase text-pink-500/40 font-bold mx-8">Dotwork</span>
      <span className="text-xs tracking-[0.4em] uppercase text-purple-500/60 font-bold mx-8">Japanese</span>
      <span className="text-xs tracking-[0.4em] uppercase text-pink-500/40 font-bold mx-8">Fine Line</span>
      <span className="text-xs tracking-[0.4em] uppercase text-purple-500/60 font-bold mx-8">Lettering</span>
      <span className="text-xs tracking-[0.4em] uppercase text-pink-500/40 font-bold mx-8">Geometric</span>
      <span className="text-xs tracking-[0.4em] uppercase text-purple-500/60 font-bold mx-8">Watercolor</span>
      <span className="text-xs tracking-[0.4em] uppercase text-pink-500/40 font-bold mx-8">Tribal</span>
    </Marquee>
  </div>
);
